import { Component, OnInit, Input } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { LangService } from "src/app/services/lang/lang.service";
import { WinService } from "src/app/services/win.service";
import { Router, ActivatedRoute } from "@angular/router";
import { SessionService } from "src/app/services/session.service";
import { OrderService } from "src/app/services/api/order.service";
import { ProductService } from "src/app/services/api/product.service";
import { BsModalService, BsModalRef, ModalOptions } from "ngx-bootstrap/modal";
import { LoginComponent } from "src/app/components/modals/login/login.component";

@Component({
  selector: "app-orders",
  templateUrl: "./orders.component.html",
  styleUrls: ["./orders.component.scss"],
})
export class OrdersComponent implements OnInit {
	orderId: string;
	modalRef: BsModalRef;

	/*currentPage: any = null;*/
	page: any = 1;
	pageSize: any = 5;
	direction: any = "desc";
	orders: any = null;
	pages: any = [];
	totalPages: any = 0;

	constructor(
		public winService: WinService,
		public lang: LangService,
		public title: Title,
		public sessionService: SessionService,
		public router: Router,
		public activeRoute: ActivatedRoute,
		public orderService: OrderService,
		public productService: ProductService,
		public modalService: BsModalService
	) {}

	ngOnInit() {
		this.title.setTitle("My Orders");

		this.activeRoute.paramMap.subscribe((urlParam) => {

			if (!this.sessionService.user.isLogedIn) {
				this.router.navigate(["/"]);
			} else {
				this.setPageAndLimit(urlParam);
				/**
				 * no need to sync old orders anymore as of nov 11 2024
				 */
				// this.orderService.syncOrdersPlacedViaSocialLogin().then(res => {
				// 	this.getOrders(this.page);
				// });
				this.getOrders(this.page);
			}
			this.orderId = urlParam.get("orderId");
		});
	}

	setPageAndLimit(urlParam:any){
		this.page = 1;
		this.pageSize = 5;

		let p = urlParam.get('page');
		if(p){
			this.page = parseInt(p);
			if(!this.page){
				this.page = 1;
			}

			let isnum = /^\d+$/.test(this.page);
			if(!isnum){ this.page = 1; }
		}
		
		let l = urlParam.get('limit');
		if(l){
			this.pageSize = parseInt(l);
			let isnum = /^\d+$/.test(this.pageSize);
			if(!isnum){ this.pageSize = 1; }
		}
	}

	goToPage(page:any=null){
		if(page){
			this.page = parseInt(page);
		}

		if(this.page < 1){
			this.page = 1;
		}
		if(this.totalPages){
			if(this.page > this.totalPages){
				this.page = this.totalPages;
			}
		} else {
			this.page = 1;
		}
		this.router.navigate(['/my/orders/' + this.page]);
	}

  /**
   * open the reset modal
   */
  openModal() {
    const config: ModalOptions = {
      backdrop: "static",
      keyboard: false,
      animated: true,
      ignoreBackdropClick: true,
      initialState: {},
    };

    this.modalRef = this.modalService.show(LoginComponent, config);
    this.modalRef.content.formDisplay = "forgotpassword";
    this.modalRef.content.resetPasswordModal = true;
    this.modalRef.setClass("login-modal modal-dialog-centered");
    this.modalRef.content.onClose = (myData) => {
      this.modalRef.hide();
    };
  }

	getOrders(currentPage: any = 1, loader: boolean = false) {
		let ordersUrl = "/rest/entrelable/V1/lns-api/orders?pageSize=" + this.pageSize + "&direction=" + this.direction;
		ordersUrl += "&currentPage=" + currentPage;
		this.orders = null;
		this.orderService.makeRequest(ordersUrl, null, "GET").then((orders) => {
			let ords: any = orders;
			this.orders = ords;

			this.setPages();

			ords.items.forEach((order) => {
				let o: any = order;
				o["total_artwork"] = 0;

				order["status_label"] = "";
				if (order.status == "pending" || order.status == "processing") {
					order.status_label = this.lang.getLang("lors1");
				} else if (order.status == "artworkapproval") {
					order.status_label = this.lang.getLang("lors2");
				} else if (order.status == "waiting_for_payment") {
					order.status_label = this.lang.getLang("lors3");
				} else if (order.status == "payment_verification") {
					order.status_label = this.lang.getLang("lors4");
				} else if (order.status == "in_production") {
					order.status_label = this.lang.getLang("lors5");
				} else if (order.status == "complete") {
					order.status_label = this.lang.getLang("lors6");
				} else if (order.status == "holded") {
					order.status_label = this.lang.getLang("lors7");
				} else if (order.status == "canceled") {
					order.status_label = this.lang.getLang("l96a");
				}

				let createdAt = order.created_at.split(" ");
				order["created_at_formatted"] = "";
				if (createdAt.length == 2) {
					createdAt = createdAt[0];
					createdAt = createdAt.split("-");

					if (createdAt.length == 3) {
						order["created_at_formatted"] =
						createdAt[1] + "/" + createdAt[2] + "/" + createdAt[0];
					}
				}

				/** 
				 * hold the parent item id
				 * so that we can check if there are 2 or mor entrie in the order child items
				 * we will only take the first item in row
				 */
				let parentItemId = [];
				o.order_items = [];

				o.items.forEach((item) => {
					let _item: any = item;

					if(item.sku.match(/custom-t-shirt-/gi)){
						item.sku = 'custom-t-shirt';
						item.parent_item = item;
					}
					if(item.sku.match(/custom-canvas-tote-bag/gi)){
						item.sku = 'custom-canvas-tote-bag';
						item.parent_item = item;
					}
					
					if (_item.parent_item) {
						if(!this.orderService.inArray(_item.parent_item.item_id, parentItemId)){
							o.order_items.push(_item);
							parentItemId.push(item.parent_item.item_id);
							let product_id = _item.parent_item.product_id;
							let pImgsKey = "product_" + product_id;

							let attachUrl = "/rest/entrelable/V1/lns-orderattachment/attachment/" + _item.parent_item.quote_item_id;
							this.orderService.makeRequest(attachUrl, "", "GET").then((attach) => {
								if (typeof attach[0] != "undefined") {
									_item.attachment = attach[0];
									if (_item.attachment.id) {
										o["total_artwork"]++;
									}
								}
							});

							this.productService.getProductImage(product_id, 150, 150).then((pImage) => {
								if (pImage) {
									_item["images"] = pImage;
								}
							});
						}
					}
				});
			});
		});
	}

  /**
   * set the pages count for pagination buttons
   */
  setPages() {
    this.pages = [];
    this.totalPages = Math.ceil(
      this.orders.total_count / this.orders.search_criteria.page_size
    );
    let i: any = 0;

    for (i = 1; i <= this.totalPages; i++) {
      this.pages.push(i);
    }
  }

  get prevPage() {
    let prev = this.orders.search_criteria.current_page - 1;
    if (prev >= 1) {
      return prev;
    } else {
      return null;
    }
  }

  get nextPage() {
    let next = this.orders.search_criteria.current_page + 1;
    if (next <= this.totalPages) {
      return next;
    } else {
      return null;
    }
  }
}
